import { mapState, mapActions } from 'vuex'
import { GET_SPAAZA_USER, GET_SPAAZA_WALLET } from '@/utils/store/actionTypes'

export default {
  computed: {
    ...mapState('spaaza', {
      spaazaUser: state => state
    })
  },
  methods: {
    ...mapActions('spaaza', {
      getSpaazaUser: GET_SPAAZA_USER,
      getSpaazaWallet: GET_SPAAZA_WALLET
    })
  }
}
